import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import BranchGroupList from '../../Shared/BranchGroupList.vue';
import { printDamageReport } from './printDamageReport';

export default {
    name: 'DamageReports',
    mixins: [HelperMixin],
    components: { PaginationHelper, BranchGroupList },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewDamageReportsUi()) {
            this.logout();
            return;
        }
        // الوزارة تبدأ بقائمة المستشفيات (طلب إدارة الصيدلة 2026-10-07)؛ المرفق يرى سجله كما كان.
        if (this.isMinistryAdmin) {
            const q = this.$route.query || {};
            const branchId = Number(q.branchId);
            if (branchId) {
                this.viewMode = 'hospital';
                this.selectedBranch = { id: branchId, name: q.branchName || '' };
            } else {
                this.viewMode = q.view === 'all' ? 'all' : 'hospitals';
            }
        }
        this.ApplyFilters();
        if (this.isFacilityUser) {
            this.loadEligibleBatches();
        }
        if (this.isMinistryAdmin) {
            this.$http.GetAllBranches()
                .then((res) => { this.branches = (res.data && res.data.info) || res.data || []; })
                .catch(() => { this.branches = []; });
        }
    },

    computed: {
        isMinistryAdmin() {
            return this.isMinistryStockAdminUi();
        },
        isFacilityUser() {
            return this.canCreateDamageReportsUi();
        },
        /** السنوات المتاحة للفلتر — من السنة الحالية رجوعاً إلى بداية التشغيل. */
        yearOptions() {
            const now = new Date().getFullYear();
            const list = [];
            for (let y = now; y >= 2024; y--) list.push(y);
            return list;
        },
        selectedBatch() {
            return this.eligibleBatches.find((b) => b.id === this.createForm.productsCountId) || null;
        },
        branchGroupRows() {
            return (this.branchRows || []).map((r) => ({
                key: r.branchesId,
                id: r.branchesId,
                name: r.branchName || '—',
                total: r.totalQuantity || 0,
                lastDate: r.lastOn,
                badges: [
                    { label: 'بلا إجراء', value: r.pending, cls: 'bg-label-warning' },
                    { label: 'حُرق', value: r.burned, cls: 'bg-label-dark' },
                    { label: 'أُرجع للشركة', value: r.returned, cls: 'bg-label-info' },
                    { label: 'باقٍ', value: r.kept, cls: 'bg-label-secondary' },
                    { label: 'بلاغات', value: r.reports, cls: 'bg-label-primary' },
                ],
            }));
        },
        /** الحرق والإرجاع نهائيان — تحذير صريح قبل الحفظ. */
        dispositionIsFinal() {
            return this.dispositionForm.disposition === 1 || this.dispositionForm.disposition === 2;
        },
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            statusFilter: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            createDialog: false,
            batchSearch: '',
            eligibleBatches: [],
            createForm: {
                productsId: null,
                productsCountId: null,
                quantity: 1,
                reason: 1,
                note: '',
                imagePaths: ''
            },
            reviewDialog: false,
            reviewForm: {
                id: 0,
                approve: true,
                reviewNote: ''
            },

            // ── سجل التالف (طلب إدارة الصيدلة 2026-10-04) ──
            yearFilter: 0,
            dispositionFilter: 0,
            reasonFilter: 0,
            branchFilter: null,
            branches: [],
            summary: null,

            // ── العرض حسب المستشفى (للوزارة) ──
            // hospitals: قائمة المستشفيات · hospital: سجل مستشفى · all: السجل الكامل كما كان
            viewMode: 'all',
            selectedBranch: null,
            branchRows: [],
            branchLoading: false,

            // ── الإجراء المتخذ ──
            dispositionDialog: false,
            dispositionTarget: null,
            dispositionForm: {
                disposition: 1,
                reference: '',
                note: ''
            },
        };
    },

    methods: {
        statusLabel(s) {
            if (s === 1) return 'مرسل';
            if (s === 2) return 'معتمد';
            if (s === 3) return 'مرفوض';
            return '-';
        },
        reasonLabel(r) {
            if (r === 1) return 'انتهاء صلاحية';
            if (r === 2) return 'سوء تخزين';
            if (r === 3) return 'سوء نقل';
            return 'أخرى';
        },
        dispositionBadge(d) {
            if (d === 1) return 'bg-label-dark';
            if (d === 2) return 'bg-label-info';
            if (d === 3) return 'bg-label-warning';
            return 'bg-label-secondary';
        },
        /** كل فلتر يمرّ من هنا: الملخص من القائمة دائماً، وقائمة المستشفيات في وضعها. */
        ApplyFilters() {
            this.GetInfo(1);
            if (this.viewMode === 'hospitals') this.loadBranchGroups();
        },

        loadBranchGroups() {
            this.branchLoading = true;
            return this.$http.GetDamageReportsByBranch(this.Search, this.statusFilter, {
                year: this.yearFilter || null,
                disposition: this.dispositionFilter || null,
                reason: this.reasonFilter || null,
            })
                .then((r) => { this.branchRows = (r && r.data && r.data.info) || []; })
                .catch(() => { this.branchRows = []; })
                .finally(() => { this.branchLoading = false; });
        },

        /** المرفق المعروض: المستشفى المفتوح، أو فلتر «المرفق» في السجل الكامل. */
        effectiveBranchId() {
            if (this.viewMode === 'hospital' && this.selectedBranch) return this.selectedBranch.id;
            if (this.viewMode === 'hospitals') return null;
            return this.branchFilter || null;
        },

        openBranch(row) {
            this.selectedBranch = { id: row.id, name: row.name };
            this.switchView('hospital');
        },

        switchView(mode) {
            this.viewMode = mode;
            if (mode !== 'hospital') this.selectedBranch = null;
            const query = {};
            if (mode === 'hospital' && this.selectedBranch) {
                query.branchId = String(this.selectedBranch.id);
                query.branchName = this.selectedBranch.name;
            } else if (mode === 'all') {
                query.view = 'all';
            }
            this.$router.replace({ path: this.$route.path, query }).catch(() => { });
            this.ApplyFilters();
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetDamageReports(this.pageNo, this.pageSize, this.Search, this.statusFilter, {
                year: this.yearFilter || null,
                disposition: this.dispositionFilter || null,
                reason: this.reasonFilter || null,
                branchId: this.effectiveBranchId(),
            })
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.summary = response.data.summary || null;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                    this.summary = null;
                });
        },

        // ── الإجراء المتخذ ──
        openDisposition(item) {
            this.dispositionTarget = item;
            this.dispositionForm = { disposition: 1, reference: '', note: '' };
            this.dispositionDialog = true;
        },
        submitDisposition() {
            if (!this.dispositionTarget) return;
            const save = () => {
                this.$blockUI.Start();
                this.$http.RecordDamageDisposition({
                    id: this.dispositionTarget.id,
                    disposition: Number(this.dispositionForm.disposition),
                    reference: this.dispositionForm.reference || null,
                    note: this.dispositionForm.note || null,
                })
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'تم', (response.data && response.data.message) || 'تم تسجيل الإجراء.');
                        this.dispositionDialog = false;
                        this.GetInfo(this.pageNo);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                        this.$helper.ShowMessage('error', 'خطأ', msg);
                    });
            };

            // الحرق والإرجاع يُخرجان الكمية من مخزن التالف بلا رجعة — تأكيد صريح.
            if (this.dispositionIsFinal) {
                this.$confirm(
                    `سيُشطب ${this.dispositionTarget.quantity} من مخزن التالف نهائياً، ويبقى البلاغ في السجل. متابعة؟`,
                    'إجراء نهائي',
                    { confirmButtonText: 'تأكيد', cancelButtonText: 'تراجع', type: 'warning' }
                ).then(save).catch(() => { });
                return;
            }
            save();
        },
        loadEligibleBatches() {
            this.$http.GetEligibleDamageBatches(this.batchSearch)
                .then((response) => {
                    this.eligibleBatches = response.data.info || [];
                })
                .catch(() => {
                    this.eligibleBatches = [];
                });
        },
        openCreateDialog() {
            this.createForm = {
                productsId: null,
                productsCountId: null,
                quantity: 1,
                reason: 1,
                note: '',
                imagePaths: ''
            };
            this.batchSearch = '';
            this.loadEligibleBatches();
            this.createDialog = true;
        },
        onBatchChange() {
            const batch = this.eligibleBatches.find((item) => item.id === this.createForm.productsCountId);
            if (!batch) return;
            this.createForm.productsId = batch.productsId;
            this.createForm.quantity = batch.quantity > 0 ? 1 : 0;
            // المنتهي يُنقل كله عادةً، وسببه معروف — يُضبطان تلقائياً ويبقيان قابلين للتعديل.
            if (batch.isExpired) {
                this.createForm.quantity = batch.quantity;
                this.createForm.reason = 1;
            }
        },
        submitCreate() {
            if (!this.createForm.productsId || !this.createForm.productsCountId || Number(this.createForm.quantity) <= 0) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر دفعة وحدد كمية صالحة.');
                return;
            }
            const body = {
                productsId: this.createForm.productsId,
                productsCountId: this.createForm.productsCountId,
                quantity: Number(this.createForm.quantity),
                reason: Number(this.createForm.reason),
                note: this.createForm.note || null,
                imagePaths: this.createForm.imagePaths || null
            };
            this.$blockUI.Start();
            this.$http.CreateDamageReport(body)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data.message || 'تم نقل الكمية إلى مخزن التالف.');
                    this.createDialog = false;
                    this.GetInfo(1);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openDetail(item) {
            this.$blockUI.Start();
            this.$http.GetDamageReport(item.id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openReview(approve) {
            this.reviewForm = {
                id: this.detail.id,
                approve,
                reviewNote: ''
            };
            this.reviewDialog = true;
        },
        submitReview() {
            this.$blockUI.Start();
            this.$http.ReviewDamageReport(this.reviewForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data);
                    this.reviewDialog = false;
                    this.detailDialog = false;
                    this.detail = null;
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        printDetail() {
            if (!this.detail || !this.detail.canPrint) return;
            this.$http.MarkDamageReportPrinted(this.detail.id)
                .then(() => {
                    const opened = printDamageReport(this.detail);
                    if (!opened) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'تعذر فتح نافذة الطباعة.');
                        return;
                    }
                    this.openDetail({ id: this.detail.id });
                })
                .catch((err) => {
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تسجيل الطباعة.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        }
    }
};
